import { render, staticRenderFns } from "./AddPersonAssetDialog.vue?vue&type=template&id=27e54ff3&scoped=true&"
import script from "./AddPersonAssetDialog.vue?vue&type=script&lang=js&"
export * from "./AddPersonAssetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e54ff3",
  null
  
)

export default component.exports